import { useState } from 'react';
import { navItems } from '@/mocks/homeData';

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-background-50/95 backdrop-blur-sm border-b border-background-200/70">
      <nav className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-[64px] max-w-[1400px] mx-auto">
          <a href="#hero" className="flex items-center gap-2 whitespace-nowrap no-underline">
            <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
              <i className="ri-fire-line text-background-50 text-lg"></i>
            </span>
            <span className="text-[15px] font-bold text-foreground-900 font-heading hidden sm:inline">
              51吃瓜网
            </span>
          </a>

          <div className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className="px-3 py-2 text-[13px] font-medium text-foreground-600 hover:text-primary-600 transition-colors rounded-md hover:bg-primary-50 whitespace-nowrap no-underline"
              >
                {item.label}
              </a>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <a
              href="#media"
              className="inline-flex items-center gap-1.5 px-4 py-2 text-[13px] font-semibold bg-primary-500 text-background-50 rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap no-underline"
            >
              <i className="ri-play-circle-line text-sm"></i>
              立即吃瓜
            </a>
          </div>

          <button
            onClick={() => setMenuOpen(!menuOpen)}
            className="md:hidden w-9 h-9 flex items-center justify-center rounded-md text-foreground-700 hover:bg-background-100 transition-colors"
            aria-label="菜单"
          >
            <i className={`text-lg ${menuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {menuOpen && (
          <div className="md:hidden pb-4 border-t border-background-200/70">
            <div className="flex flex-col gap-1 pt-3">
              {navItems.map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  onClick={() => setMenuOpen(false)}
                  className="px-3 py-2.5 text-[14px] font-medium text-foreground-700 hover:text-primary-600 hover:bg-primary-50 rounded-md transition-colors whitespace-nowrap no-underline"
                >
                  {item.label}
                </a>
              ))}
              <a
                href="#media"
                onClick={() => setMenuOpen(false)}
                className="mt-2 inline-flex items-center justify-center gap-1.5 px-4 py-2.5 text-[14px] font-semibold bg-primary-500 text-background-50 rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap no-underline"
              >
                <i className="ri-play-circle-line"></i>
                立即吃瓜
              </a>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}